import type { ReduxState } from '@/redux/app/state';

export const eventsForTicketDataSelector = (ticketId: string, state: ReduxState) =>
  state.event.data[ticketId]?.data;

export const eventsForTicketCountSelector = (ticketId: string, state: ReduxState) =>
  Object.keys(eventsForTicketDataSelector(ticketId, state) ?? {}).length;

export const eventsForTicketUpwardsLoadingStatusSelector = (ticketId: string, state: ReduxState) =>
  state.event.data[ticketId]?.upwardsLoadingStatus;

export const eventsForTicketDownwardsLoadingStatusSelector = (ticketId: string, state: ReduxState) =>
  state.event.data[ticketId]?.downwardsLoadingStatus;

export const eventsForTicketUpwardsKeySelector = (ticketId: string, state: ReduxState) =>
  state.event.data[ticketId]?.upwardsKey;

export const eventsForTicketDownwardsKeySelector = (ticketId: string, state: ReduxState) =>
  state.event.data[ticketId]?.downwardsKey;

export const eventDataSelector = (ticketId: string, eventId: string, state: ReduxState) =>
  eventsForTicketDataSelector(ticketId, state)?.[eventId];

export const eventElementTypeSelector =
  (ticketId: string, eventId: string, state: ReduxState): string =>
    eventDataSelector(ticketId, eventId, state)?.element_type;

export const eventElementDataSelector = (ticketId: string, eventId: string, state: ReduxState) =>
  eventDataSelector(ticketId, eventId, state)?.element_data;

export const mmsContentDimensions =
  (ticketId: string, eventId: string, contentUrl: string, state: ReduxState) =>
    eventElementDataSelector(ticketId, eventId, state)
      ?.contents?.find?.((x) => x.url === contentUrl)?.dimensions as number;

export const eventAbortStatus = (ticketId: string, eventId: string, state: ReduxState) =>
  eventDataSelector(ticketId, eventId, state)?.abortStatus;

export const eventUpdateStatus = (ticketId: string, eventId: string, state: ReduxState) =>
  eventDataSelector(ticketId, eventId, state)?.updateStatus;

export const eventUpdateError = (ticketId: string, eventId: string, state: ReduxState) =>
  eventDataSelector(ticketId, eventId, state)?.updateError;

export const eventSendNowStatus = (ticketId: string, eventId: string, state: ReduxState) =>
  eventDataSelector(ticketId, eventId, state)?.sendNowStatus;

export const eventSendNowError = (ticketId: string, eventId: string, state: ReduxState) =>
  eventDataSelector(ticketId, eventId, state)?.sendNowError;
